export function getCalculatedServiceTime(
  trackingData: uui.domain.client.rm.OrderStepTrackingData,
  rescheduleBehavior: uui.domain.client.rm.Territory['rescheduleBehavior'],
) {
  const { timeInSec, timeOutSec, autoTimeInSec, autoTimeOutSec } = trackingData

  const hasReportedValue = timeInSec > -1 && timeOutSec > -1
  const hasDetectedValue = autoTimeInSec > -1 && autoTimeOutSec > -1

  const deltaReportedValue = timeOutSec - timeInSec
  const deltaDetectedValue = autoTimeOutSec - autoTimeInSec

  let timeDeltaSec = -1
  let source: 'reported' | 'detected' | null = null

  if (hasDetectedValue || hasReportedValue) {
    switch (rescheduleBehavior) {
      case 'ON_REPORTED_FIRST':
        if (hasReportedValue) {
          timeDeltaSec = deltaReportedValue
          source = 'reported'
        } else if (hasDetectedValue) {
          timeDeltaSec = deltaDetectedValue
          source = 'detected'
        }
        break

      case 'ON_DETECTED_FIRST':
        if (hasDetectedValue) {
          timeDeltaSec = deltaDetectedValue
          source = 'detected'
        } else if (hasReportedValue) {
          timeDeltaSec = deltaReportedValue
          source = 'reported'
        }
        break

      case 'ON_REPORTED_ONLY':
        if (hasReportedValue) {
          timeDeltaSec = deltaReportedValue
          source = 'reported'
        }
        break

      case 'ON_DETECTED_ONLY':
        if (hasDetectedValue) {
          timeDeltaSec = deltaDetectedValue
          source = 'detected'
        }
        break
    }
  }

  return { timeDeltaSec, source }
}
